// node_modules
import { CSSProperties, FC } from "react";
// styles
import styles from "./label.module.scss";

type TLabelProps = {
    text: string,
    backgroundColor?: string,
    color?: string
};

export const Label: FC<TLabelProps> = ({text, backgroundColor, color}: TLabelProps) => {
    // Logic
    const getOverrodeLabelColors = (): CSSProperties => {
        const labelColors: CSSProperties = {};
        if (backgroundColor) {
            labelColors.backgroundColor = backgroundColor;
        }
        if (color) {
            labelColors.color = color;
        }
        return labelColors;
    };

    // Render
    return (
        <div 
            style={getOverrodeLabelColors()}
            className={styles.label}>
            {text}
        </div>
    );
};